import React from "react";
import "./index.scss";
import HeaderAction from "../components/HeaderAction";
import TitleLogo from "../components/TitleLogo";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { curStateAccount } from "../../../../Redux/selector";
import { useTranslation } from "react-i18next";
import buyCoinType1 from "../../../../assets/images/Mini-Game/buy-more-coin-type1.png";
import buyCoinType2 from "../../../../assets/images/Mini-Game/buy-more-coin-type2.png";
import buyCoinType3 from "../../../../assets/images/Mini-Game/buy-more-coin-type3.png";
import { Button, Tabs } from "antd";
import BuyCoinItem from "./BuyCoinItem";
import coinIllu from "../../../../assets/images/Mini-Game/buy-more-coin-illu.png"
import logoBuyMoreCoin from "../../../../assets/images/Mini-Game/logo-buy-more-coin.png";

export default function MiniGameBuyMoreCoin() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const selectorAccount = useSelector(curStateAccount);
  const handleTopage = (id) => {
    navigate();
  };

  const tabItems = [
    {
      key: "sub-package",
      label: (
        <Button className='btn-tab btn-sub-package'>
          <span>Sub package</span>
        </Button>
      ),
      children: (
        <div className='tab-content'>
          <BuyCoinItem
            data={{
              image: buyCoinType1,
              packageName: "Daily - 2 coins per day",
              packageValue: "149 MMK",
              validTime: "Valid until 23:59:59 tomorrow",
            }}
          />

          <BuyCoinItem
            data={{
              image: buyCoinType2,
              packageName: "Weekly - 10 coins per week",
              packageValue: "849 MMK",
              validTime: "Valid for 7 days",
            }}
          />

          <BuyCoinItem
            status={1}
            data={{
              image: buyCoinType3,
              packageName: "Monthly - 20 coins per month",
              packageValue: "2,499 MMK",
              validTime: "Valid for 30 days",
            }}
          />
        </div>
      ),
    },
    {
      key: "retail-package",
      label: (
        <Button className='btn-tab btn-retail-package'>
          <span>Retail package</span>
        </Button>
      ),
      children: (
        <div className='tab-content'>
          <BuyCoinItem
            data={{
              image: buyCoinType1,
              packageName: "COIN1 - 1 Coin",
              packageValue: "99 MMK",
              validTime: "Valid for 14 days",
            }}
          />

          <BuyCoinItem
            data={{
              image: buyCoinType2,
              packageName: "COIN2 - 2 Coin",
              packageValue: "195 MMK",
              validTime: "Valid for 14 days",
            }}
          />

          <BuyCoinItem
            data={{
              image: buyCoinType3,
              packageName: "COIN5 - 5 Coin",
              packageValue: "462 MMK",
              validTime: "Valid for 14 days",
            }}
          />
        </div>
      ),
    },
  ];
  return (
    <div className='container-minigame buy-more-coin'>
      <div className='minigame-home-header position-relative'>
        <HeaderAction />
        <TitleLogo logo={logoBuyMoreCoin} className="title-logo" />
        {/* <ActionComponent /> */}
        <div className="tabs-wrapper position-relative">
          <Tabs items={tabItems} centered>
          
          </Tabs>
           <img src={coinIllu} alt='' className="coin-illu" />
        </div>
      </div>
    </div>
  );
}
